import * as React from 'react';
import InsuranceDiscovery from '../InsuranceDiscovery';
import { LeadInsuranceDetails } from '../../../../types';
import * as Style from './style.module.scss';

interface InsuranceTabsProps {
    primaryUserInsurances?: LeadInsuranceDetails[] | null;
}

const InsuranceTabs: React.FC<InsuranceTabsProps> = ({ primaryUserInsurances }) => {
    const preparedInsurances = primaryUserInsurances?.map((insurance, index) => ({
        ...insurance,
        id: index + 1
    }));

    const [insuranceId, selectInsuranceId] = React.useState(1);

    const tabs = preparedInsurances?.map((insurance) => ({
        label: insurance.payer,
        id: insurance.id
    }));

    const selectedInsurance = preparedInsurances?.find((insurance) => insurance.id === insuranceId);

    return (
        <>
            <div className={Style.nav}>
                {tabs?.map((tabItem) => (
                    <button
                        type="button"
                        className={tabItem.id === insuranceId ? Style.active : ''}
                        key={`${tabItem.id}-${tabItem.label}`}
                        onClick={() => selectInsuranceId(tabItem.id)}
                    >
                        {tabItem.label}
                    </button>
                ))}
            </div>
            {selectedInsurance ? (
                <InsuranceDiscovery insuranceDiscovery={selectedInsurance} />
            ) : null}
        </>
    );
};

export default InsuranceTabs;
